module.exports = __webpack_public_path__ + "static/img/storageImg3.b9d7779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageImg3.png
// module id = 56Ta
// module chunks = 2